"use client";

import { useClerk } from "@clerk/nextjs";
import { usePostHog } from "posthog-js/react";
import { useState } from "react";

import { Button } from "@/components/buttons/Button";
import { logError } from "@/utils/logError";

export function SignOutButton() {
  const postHog = usePostHog();
  const { signOut } = useClerk();

  const [isLoading, setIsLoading] = useState(false);

  const handleSignOut = async () => {
    try {
      setIsLoading(true);
      postHog.reset();
      await signOut();
    } catch (error) {
      console.error("Could not sign out", error);
      logError("Could not sign out");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button onClick={handleSignOut} loading={isLoading}>
      Log out
    </Button>
  );
}
